module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [(_vm.error) ? _c('error-indicator', {
    attrs: {
      "error": _vm.error
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "text",
      "name": "login",
      "placeholder": "E-Mail/Benutzername"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Passwort"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.invalid) ? _c('div', {
    staticClass: "ui orange message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.invalid = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Anmeldung fehlgeschlagen\n    ")]), _vm._v("\n    Der Benutzername und/oder Passwort ist falsch.\n  ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "recover",
    attrs: {
      "to": "/recover"
    }
  }, [_vm._v("Passwort vergessen?")]), _vm._v(" "), _c('button', {
    staticClass: "ui fluid green submit button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Anmelden")]), _vm._v(" "), (_vm.loading) ? _c('loading-indicator') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c3cd2eda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/login/components/page.vue
// module id = 362
// module chunks = 0